import { ColorEnum } from '@/constants/color'
import type { CatalogSection } from '@/features/openTabs/components/ProductCatalog'
import ProductCard from '@/features/openTabs/components/ProductCatalog/parts/ProductCard'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet } from 'react-native-unistyles'

interface ProductSectionProps {
    disabled?: boolean
    section: CatalogSection
    numColumns?: number
    selectedProductIds: ReadonlySet<string>
    onSelect: (productId: string) => void
}

const ProductSection: FC<ProductSectionProps> = ({
    disabled = false,
    section,
    numColumns = 2,
    selectedProductIds,
    onSelect,
}) => {
    const rows = []

    for (let index = 0; index < section.products.length; index += numColumns) {
        const products = section.products.slice(index, index + numColumns)

        rows.push(
            <View style={styles.row} key={`${section.id}-${index}`}>
                {products.map((product) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                        selected={selectedProductIds.has(product.id)}
                        disabled={disabled || product.soldOut}
                        onPress={() => onSelect(product.id)}
                    />
                ))}
                {Array.from({ length: numColumns - products.length }, (_, cellIndex) => (
                    <View style={styles.emptyCell} key={`empty-${cellIndex}`} />
                ))}
            </View>
        )
    }

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Typography.Description font="medium" numberOfLines={1}>
                    {section.name}
                </Typography.Description>
                <View style={styles.divider} />
            </View>
            <View style={styles.rows}>{rows}</View>
        </View>
    )
}

const styles = createStyleSheet({
    container: {
        gap: 8,
    },
    header: {
        height: 24,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    divider: {
        flex: 1,
        height: 1,
        backgroundColor: ColorEnum.GRAY_300,
    },
    rows: {
        gap: 8,
    },
    row: {
        flexDirection: 'row',
        gap: 8,
    },
    emptyCell: {
        flex: 1,
    },
})

export default ProductSection
